import { Controller } from '@hotwired/stimulus';
import { Collapse } from 'bootstrap/dist/js/bootstrap.bundle.min.js';

export default class extends Controller {
  static targets = ['body'];
  static values = {
    cookieId: { type: String }
  };

  connect() {
    this.bsCollapse = new Collapse(this.bodyTarget, { toggle: false });
    this.bodyTarget.addEventListener('shown.bs.collapse', () => this.#saveState(true));
    this.bodyTarget.addEventListener('hidden.bs.collapse', () => this.#saveState(false));
  }

  disconnect() {
    this.bodyTarget.removeEventListener('shown.bs.collapse', () => this.#saveState(true));
    this.bodyTarget.removeEventListener('hidden.bs.collapse', () => this.#saveState(false));
    this.bsCollapse?.dispose();
  }

  #saveState(expanded) {
    console.log('Changing state', expanded);
    this.#setCookie(this.cookieIdValue, expanded ? 'expanded' : 'collapsed');
  }

  #setCookie(name, value) {
    console.log('Storing cookie', name);
    const ONE_YEAR_IN_SECONDS = 60 * 60 * 24 * 365;
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${ONE_YEAR_IN_SECONDS}`;
  }
}
